import ContentList, { ContentListBaseProps } from './ContentList';

export default function ContentOrderedList(props: ContentListBaseProps) {
    return <ContentList items={props.items} key={props.id} id={props.id.toString()} type='ol' />;
}
